import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext, useEffect, useState } from 'react';

import CountriesChart from './Countries';
import CountryLink from 'Components/common/CountryLink';
import NoteBox from 'Components/common/NoteBox';
import SmartText from '@reuters-graphics/react-smart-text';
import VaccineRefferal from 'Components/common/VaccineReferral';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import fetchJson from 'Utils/fetchJson';
import maxBy from 'lodash/maxBy';
import { roundDownSmart } from 'Utils/roundDown';

const Vaccination = (props) => {
  const [data, setData] = useState(null);

  const content = useContext(ContentContext);
  const locale = useContext(LocaleContext);

  useEffect(() => {
    const fetchData = async() => {
      const data = await fetchJson('https://graphics.thomsonreuters.com/data/2020/coronavirus/owid-covid-vaccinations/latest-perpop-data-all.json');
      setData(data);
    };
    fetchData();
  }, []);

  if (!data || !content.template.vaccination) return null;

  const countries = data.filter(d => d.totalDoses > 0).length;
  const topCountry = maxBy(data, d => parseFloat(d.perPop));

  const percentVaccinated = topCountry.totalDoses / (topCountry.population * 2);

  const totalDoses = data.reduce((a, d) => a + d.totalDoses, 0);

  return (
    <div className={classnames(component)}>
      <section>
        <VaccineRefferal />
        <h4>{content.template.vaccination.title}</h4>
        
        <SmartText
          source={content.template.vaccination.intro}
          context={{
            countries: countries.toString(),
            totalDoses: roundDownSmart(totalDoses).toLocaleString(locale),
            topCountry: <CountryLink country={data[0].countryISO} />,
            percent: Math.round(percentVaccinated * 100).toLocaleString(locale),
          }}
          multiline
        />
        <NoteBox
          title={content.template.vaccination.infobox.title}
          source={content.template.vaccination.infobox.text}
        />
        <CountriesChart vaccinationData={data} />
      </section>
    </div>
  );
};

export default Vaccination;
